export const RPR_TOKEN = 'EE6A11F4-EC71-46F7-82BB-EFF0B38B4D15';
export const RPR_CBCODE = 'btsrichrhomes';
export const RPR_WIDGET_URL =
  'https://www.narrpr.com/widgets/avm-widget/widget.ashx/html';
export const BOOKING_LINK = 'https://links.richr.com/schedule-time';
export const media = {
  lockIcon: '/static/images/home-valuation/lock-icon.svg',
  reportBlur: '/static/images/home-valuation/report-blur.jpg',
  valueBlur: '/static/images/home-valuation/value-blur.jpg',
  richrLogo: '/static/logo-richr-new.svg',
  thankYouImage: '/static/images/home-valuation/thank-you.svg',
};

export const schemaJson = {
  '@context': 'http://schema.org',
  '@type': 'WebPage',
  name: 'Free Home Valuation Tool',
  description:
    "Get a free estimate of your home's value with Richr's home valuation tool. Our proprietary algorithm analyzes data from recent home sales in your area to provide you with an accurate valuation.",
  publisher: {
    '@type': 'Organization',
    name: 'Richr',
    logo: {
      '@type': 'ImageObject',
      url: 'https://richr.com/logo.png',
      width: '200',
      height: '200',
    },
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://richr.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Free Home Valuation Tool',
        item: 'https://richr.com/free-home-valuation',
      },
    ],
  },
};
